export enum GbGemeindeSearchMode {
  RECHTE_REGISTER_SEARCH,
  GRUNDSTEUCK_REGISTER_SEARCH,
  GRUNDBUCHGESCHAEFT_SEARCH,
  GRUNDBUCHMELDUNG_REGISTER_SEARCH,
  GEOMETERGESCHAEFT_SEARCH,
  GWR_GEBAEUDE_SEARCH,
  GWR_BAUPROJEKT_SEARCH,
  PUBLIKATIONS_REGISTER_SEARCH,
  NESKOAB_REGISTER_SEARCH,
  ALTE_GRUNDBUCHMELDUNG_REGISTER_SEARCH
}
